import { render } from "./base.vue?vue&type=template&id=3ec5d73f"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"

import "./base.vue?vue&type=style&index=0&id=3ec5d73f&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__